import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AdBanner = ({ className = "" }) => {
  const [ads, setAds] = useState([]);
  const [i, setI] = useState(0);
  const [sec, setSec] = useState(3);

  useEffect(() => {
    axios.get(`${API}/public/ads`).then((r) => setAds(r.data || [])).catch(() => {});
    axios.get(`${API}/public/ads-config`).then((r) => setSec(Number(r.data?.interval_sec) || 3)).catch(() => {});
  }, []);

  useEffect(() => {
    if (ads.length < 2) { return; }
    const t = setInterval(() => setI((x) => (x + 1) % ads.length), sec * 1000);
    return () => { clearInterval(t); };
  }, [ads.length, sec]);

  if (!ads.length) return null;

  return (
    <div className={`max-w-6xl mx-auto px-4 sm:px-6 ${className}`} data-testid="ad-banner">
      <div className="relative overflow-hidden rounded-2xl shadow-md bg-slate-200 aspect-[3/1]">
        <div className="flex h-full transition-transform duration-700 ease-out" style={{ transform: `translateX(-${i * 100}%)` }}>
          {ads.map((a, k) => {
            const img = <img src={a.image} alt={`Ad ${k + 1}`} className="w-full h-full object-cover" draggable={false} />;
            return (
              <div key={a.id} className="w-full h-full shrink-0" data-testid={`ad-slide-${k}`}>
                {a.link ? <a href={a.link} target="_blank" rel="noopener noreferrer" className="block w-full h-full">{img}</a> : img}
              </div>
            );
          })}
        </div>
        {ads.length > 1 && (
          <div className="absolute bottom-2 left-0 right-0 flex justify-center gap-1.5">
            {ads.map((a, k) => (
              <button key={a.id} onClick={() => setI(k)} aria-label={`Slide ${k + 1}`} className={`h-2 rounded-full transition-[width,background-color] duration-300 ${k === i ? "w-6 bg-white" : "w-2 bg-white/60"}`} data-testid={`ad-dot-${k}`} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
